
import { useState } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

import { postActiveVisits } from "../../../../MyApi/sb/vistits";

import VisitModal from "../visitshowmodal";


const SingleVisit = ({ visit, refetch }) => {
  const {
    id,
    employe,
    sb_branch_device_id,
    lat,
    long,
    hr_attendance_id,
    type,
    operation,
    start_date,
    end_date,
    note,
    out_lat,
    out_long,
    out_sb_branch_device_id,
    out_type,
    out_operation,
    out_note,
    active
  } = visit;

const [isModalOpen,setIsModalOpen]=useState(false)
const [rowId ,setRowId]=useState("")



 let startDate = ""
 let startTime=""
 let endDate = "";
 let endTime = "";

 const openModal =(id)=>{
  setIsModalOpen(true)
  setRowId(id)
}
const closeModal =()=>{
  setIsModalOpen(false)
}

  if(start_date){
    const [datePart, timePart] = start_date.trim().split(" ");
    startDate=datePart
    startTime=timePart
  }
  

  
  if (end_date) {
    const [datePart, timePart] = end_date.trim().split(" ");
    endDate = datePart;
    endTime = timePart;
  }


  return (
    <>
      <tr>
      <td>{id}</td>
      <td className="text-warning">{employe}</td>
      <td className="text-success">
      <i className="fa  fa-calendar"></i> {startDate}
        <br></br>
       <i className="fa fa-clock-o"></i>  {startTime}
      </td>
      <td className="text-danger">
         <i className="fa  fa-calendar"></i> {endDate}
        <br></br>
        <i className="fa fa-clock-o"></i> {endTime}
      </td>
 
      <td>
        <div>
          <div role="group" class="btn-group">
            <button
              class="btn btn-success"
              onClick={() =>
                openModal(id)
              }>
              <i class="fa fa-eye"></i>
            </button>
          </div>
        </div>
      </td>
    </tr>
    {isModalOpen && <VisitModal closeModal={closeModal} rowId={rowId}/>}
    </>
  
  );
};

export default SingleVisit;
